import { SALE_STATUSES, calculateSalesTotals } from './orderSales';

export function homeStats(payload, now = new Date()) {
  const orders = Array.isArray(payload) ? payload : payload?.orders;
  if (!Array.isArray(orders) || orders.some(order => !order ||
      typeof order.orderId !== 'string' || !order.orderId || typeof order.status !== 'string' ||
      !Number.isFinite(new Date(order.createdAt).getTime()) || !Array.isArray(order.items) ||
      order.items.some(item => !item || !['number', 'string'].includes(typeof item.price) || String(item.price).trim() === '' || !Number.isFinite(Number(item.price)) ||
        Number(item.price) < 0 || !Number.isSafeInteger(Number(item.quantity ?? 1)) || Number(item.quantity ?? 1) < 1))) {
    throw new Error('Invalid orders response');
  }
  const unique = [...new Map(orders.map(order => [order.orderId, order])).values()];
  const today = new Date(now); today.setHours(0, 0, 0, 0);
  return {
    ordersToday: unique.filter(order => SALE_STATUSES.has(order.status.toLowerCase()) &&
      new Date(order.createdAt) >= today && new Date(order.createdAt) <= now).length,
    totals: calculateSalesTotals(unique.map(({ totalAmount, ...order }) => order), now),
  };
}
